/**
 * Route pattern → help article id.
 * Patterns use :param for dynamic segments. Longer / more specific patterns win.
 */
export const HELP_ROUTE_ENTRIES = [
  { pattern: '/home/settings', articleId: 'launcher-settings' },
  { pattern: '/home', articleId: 'home-launcher' },
  { pattern: '/dashboard', articleId: 'dashboard' },
  { pattern: '/activity-feed', articleId: 'activity-feed' },
  { pattern: '/collaboration/:workspaceId', articleId: 'collaboration-runtime' },
  { pattern: '/studio/:workspaceId', articleId: 'workspace-studio' },
  { pattern: '/studio', articleId: 'workspace-studio' },
  { pattern: '/admin/contact-lists', articleId: 'contact-lists' },
  { pattern: '/admin/collaboration-workspaces/:workspaceId', articleId: 'collaboration-workspaces' },
  { pattern: '/admin/collaboration-workspaces', articleId: 'collaboration-workspaces' },
  { pattern: '/admin/touch-panels/:panelId', articleId: 'touch-panel-designer' },
  { pattern: '/admin/touch-panels', articleId: 'touch-panels' },
  { pattern: '/admin/event-system/flows', articleId: 'unified-flows' },
  { pattern: '/admin/event-system/actions', articleId: 'actions' },
  { pattern: '/admin/event-system/devices', articleId: 'devices' },
  { pattern: '/admin/event-system/logs', articleId: 'logs' },
  { pattern: '/admin/event-system/incoming-events', articleId: 'incoming-events' },
  { pattern: '/admin/event-system/inbound-rules', articleId: 'inbound-rules' },
  { pattern: '/admin/event-system/scheduled', articleId: 'scheduled-triggers' },
  { pattern: '/admin/event-system/simple-actions', articleId: 'simple-actions' },
  { pattern: '/admin/event-system/call-routing', articleId: 'call-routing' },
  { pattern: '/admin/event-system/sip-interworking', articleId: 'sip-interworking' },
  { pattern: '/admin/event-system/templates', articleId: 'event-templates' },
  { pattern: '/admin/tenants', articleId: 'tenant-management' },
  { pattern: '/admin/user-management', articleId: 'user-management' },
  { pattern: '/admin/agent-management', articleId: 'agent-management' },
  { pattern: '/admin/agent-dashboard', articleId: 'agent-dashboard' },
  { pattern: '/admin/sites', articleId: 'sites' },
  { pattern: '/admin/incidents/:typeKey', articleId: 'incident-type-editor' },
  { pattern: '/admin/incidents', articleId: 'incident-types' },
  { pattern: '/admin/workspaces/:id', articleId: 'home-designer-workspace-detail' },
  { pattern: '/admin/workspaces', articleId: 'home-designer-workspaces' },
  { pattern: '/admin/segment-health', articleId: 'segment-health' },
  { pattern: '/admin/voice-settings', articleId: 'voice-settings' },
  { pattern: '/admin/voice-dashboard', articleId: 'voice-dashboard' },
  { pattern: '/admin/config-editor/:deviceId', articleId: 'config-editor' },
  { pattern: '/admin/config-workspace', articleId: 'config-workspace' },
  { pattern: '/admin/config-snapshots', articleId: 'config-snapshots' },
  { pattern: '/admin/configs/:deviceId/parsed', articleId: 'config-parsed' },
  { pattern: '/admin/configs/:deviceId/validate', articleId: 'config-validate' },
  { pattern: '/admin/algo-devices', articleId: 'algo-devices' },
  { pattern: '/admin/role-editor/:userId', articleId: 'role-editor' },
  { pattern: '/admin/role-editor', articleId: 'role-editor' },
  { pattern: '/admin/test-tools', articleId: 'test-tools' },
  { pattern: '/admin/tools/rest', articleId: 'rest-test-tools' },
  { pattern: '/admin/api-test', articleId: 'api-test' },
  { pattern: '/settings', articleId: 'settings' },
  { pattern: '/support/reports', articleId: 'support-reports' },
  { pattern: '/support/detail/:reportId', articleId: 'support-report-detail' },
  { pattern: '/my-reports/detail/:reportId', articleId: 'my-reports' },
  { pattern: '/my-reports', articleId: 'my-reports' },
  { pattern: '/release-notes', articleId: 'release-notes' },
  { pattern: '/admin', articleId: 'admin-home' },
];

function patternToRegex(pattern) {
  const escaped = pattern
    .replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
    .replace(/:([A-Za-z0-9_]+)/g, '[^/]+');
  return new RegExp(`^${escaped}/?$`);
}

const compiledRoutes = HELP_ROUTE_ENTRIES.map((entry) => ({
  ...entry,
  regex: patternToRegex(entry.pattern),
  specificity: entry.pattern.split('/').filter(Boolean).length,
}));

/** Sort more specific (deeper) patterns first; stable for equal depth. */
compiledRoutes.sort((a, b) => b.specificity - a.specificity);

/**
 * Resolve a pathname to a help article id.
 * @param {string} pathname
 * @returns {{ articleId: string|null, pattern: string|null }}
 */
export function resolveHelpArticleId(pathname) {
  const path = (pathname || '/').split('?')[0].split('#')[0] || '/';

  for (const entry of compiledRoutes) {
    if (entry.regex.test(path)) {
      return { articleId: entry.articleId, pattern: entry.pattern };
    }
  }

  return { articleId: null, pattern: null };
}
